module.exports = __webpack_public_path__ + "img/hr-rock-medium-08.c2b5c15a.png";